export enum PersonaInquiryType {
  DriverLicense = 'driver_license',
  BusinessEntity = 'business_entity',
}
